import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateOrderSubprocessInput,
    ModelSortDirection,
    OrderSubprocess,
    UpdateOrderSubprocessInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class PopOrderSubprocessService {
    private amplifyClient = generateClient();

    constructor() {}

    async getPopOrderSubprocess(id: string): Promise<OrderSubprocess> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getOrderSubprocess,
                    variables: { id }
                })
            ).data.getOrderSubprocess;
            if (data) return data as OrderSubprocess;
        } catch (error) {
            console.error('Error finding PopOrderSubprocess:', error);
            return null;
        }
    }

    async listAllPopSubprocessesByProcess(
        processId: string,
        sortDirection: ModelSortDirection = ModelSortDirection.ASC,
        pageLimit: number = 100
    ): Promise<OrderSubprocess[]> {
        const subprocesses: OrderSubprocess[] = [];
        let nextToken: string | null = null;

        try {
            do {
                const response = (
                    await this.amplifyClient.graphql({
                        query: queries.OrderSubprocessesByProcess,
                        variables: {
                            processId,
                            limit: pageLimit,
                            nextToken,
                            sortDirection
                        }
                    })
                ).data.OrderSubprocessesByProcess;
                subprocesses.push(
                    ...((response?.items ?? []) as OrderSubprocess[])
                );
                nextToken = response?.nextToken ?? null;
            } while (nextToken !== null);
            return subprocesses;
        } catch (error) {
            console.error('Error finding PopOrderSubprocess:', error);
            return [];
        }
    }

    async createPopOrderSubprocess(
        input: CreateOrderSubprocessInput
    ): Promise<OrderSubprocess> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createOrderSubprocess,
                    variables: { input }
                })
            ).data.createOrderSubprocess;
            if (data) return data as OrderSubprocess;
        } catch (error) {
            console.error('Error creating PopOrderSubprocess:', error);
            return null;
        }
    }

    async updatePopOrderSubprocess(
        input: UpdateOrderSubprocessInput
    ): Promise<OrderSubprocess> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updateOrderSubprocess,
                    variables: { input }
                })
            ).data.updateOrderSubprocess;
            if (data) return data as OrderSubprocess;
        } catch (error) {
            console.error('Error updating PopOrderSubprocess:', error);
            return null;
        }
    }
}
